/**
 * UAからBotの判定をする関数
 * botの場合 true botではない場合 false
 * @return boolean
 */
export const isBot = () => {
  const botName = /bot/;
  const ua = window.navigator.userAgent.toLowerCase();
  return botName.test(ua);
};
